import React from "react";

const SummaryCards = ({ summary }) => (
    <section className="summary-grid">
        <div className="card">Budget: {summary.totalBudget.toLocaleString()}</div>
        <div className="card">Spent: {summary.totalSpent.toLocaleString()}</div>
        <div className="card">Balance: {summary.balance.toLocaleString()}</div>
        <div className="card">% Used: {summary.utilization}</div>
    </section>
);

export default SummaryCards;